import { Box } from '@chakra-ui/react';
import Todos from 'components/Todos';

function UtilityPanel() {
  return (
    <Box width="400px" p="20px">
      <Box h="100%" bg="#f2f2fd" borderRadius="2xl" p={4} textAlign="center">
        <Todos />
      </Box>
    </Box>
  );
}

export default UtilityPanel;
